import { TourStep } from 'core/tour';

import { tourSteps, workloadsTourId } from '../tourSteps';

import {
  WorkloadsTable,
  WorkloadsTableProps,
} from './_components/WorkloadsTable';
import { Box } from '@cast/design-system';

type ComputeCostWorkloadsSectionProps = WorkloadsTableProps;

export const ComputeCostWorkloadsSection = (
  props: ComputeCostWorkloadsSectionProps
) => {
  return (
    <TourStep
      step={tourSteps.rowCheckbox}
      type={workloadsTourId}
      text="Select the workloads you'd like to see in an overview."
      highlight="bubble"
      placement="top-start"
      beaconPosition={{
        top: 80,
        left: 22,
      }}
    >
      <Box className="tour-highlight" flexGrow={1} data-hc="success">
        <WorkloadsTable {...props} />
      </Box>
    </TourStep>
  );
};
